import { useFileFilter, useSetFileFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const FilesSearchInput = () => {
  const { t } = useTranslation();
  const { data: filter } = useFileFilter();
  const { mutateAsync } = useSetFileFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('file.filter.searchPlaceholder')}
    />
  );
};
